// global.js
(function (Drupal, drupalSettings) {
  Drupal.behaviors.ems = {
    attach(context) {

      var navbarEll = document.querySelector('.navbar');
      if (navbarEll) {
        window.addEventListener('scroll', function () {
          if (window.scrollY >= 56) {
            navbarEll.classList.add('navbar-scrolled');
          } else if (this.window.scrollY < 56) {
            navbarEll.classList.remove('navbar-scrolled');
          }
        });
        //        var navbarHeight = navbarEll.offsetHeight * -1;
        //        navbarEll.style.marginBottom = navbarHeight + 'px';
      }

      let placeholder = document.querySelectorAll("em.placeholder");
      [...placeholder].forEach(x => x.className += " drupal-placeholder");
      [...placeholder].forEach(x => x.classList.remove("placeholder"));

      //      const activeLinks = context.querySelectorAll('.nav-link.is-active');
      const activeLinks = context.querySelectorAll('[data-drupal-link-system-path].is-active');
      const il = activeLinks.length;
      for (let i = 0; i < il; i++) {
        activeLinks[i].classList.add('active');
      }

    },
    detach(context, settings, trigger) {
      if (trigger == 'unload') {
        //        const activeLinks = context.querySelectorAll('.nav-link.active');
        const activeLinks = context.querySelectorAll('[data-drupal-link-system-path].active');
        const il = activeLinks.length;
        for (let i = 0; i < il; i++) {
          activeLinks[i].classList.remove('active');
        }
      }
    }
  }
  Drupal.behaviors.navigation = {
    attach(context) {
      var fixable = document.querySelector('.site-header__fixable');
      if (fixable) {
        window.addEventListener('scroll', function () {
          if (window.scrollY >= 56) {
            fixable.classList.add('is-scrolled');
          } else if (this.window.scrollY < 56) {
            fixable.classList.remove('is-scrolled');
          }
        });
      }
      const stickyHeaderToggleButton = document.querySelector('.sticky-header-toggle');
      if (stickyHeaderToggleButton) {
        stickyHeaderToggleButton.addEventListener('click', () => {
          fixable.classList.toggle('is-expanded');
        });
      }
    }
  }
  Drupal.behaviors.masonry = {
    attach(context) {
      once('masonry', '.grid', context).forEach(function (el) {
        new Masonry(el, {
          itemSelector: '.grid-item',
          gutter: 10,
        });
      })
    }
  }
  Drupal.behaviors.splidex = {
    attach(context) {
      once('splidexx', '.xxxsplide-auto-scroll', context).forEach(function (el) {
        new Splide(el, {
          type: 'loop',
          drag: 'free',
          focus: 'center',
          perPage: 3,
          autoWidth: true,
          gap: '1.5rem',
          autoScroll: {
            speed: 1,
          },
          breakpoints: {
            840: {
              perPage: 1,
              gap: '.5rem',
            },
          },
        }).mount(window.splide.Extensions);
      })
    }
  }
  Drupal.behaviors.splide = {
    attach(context) {
      once('splide', '.splide', context).forEach(function (el) {
        new Splide(el, {
          type: 'loop',
          gap: '1.5rem',
        }).mount();
      })
    }
  }
  Drupal.behaviors.lmsAnswere = {
    attach(context) {
      once('lmaAnswere', '#lms-answer-form [name="answer"]', context).forEach(function (el) {
        const submit = document.querySelector('#edit-submit');
        el.addEventListener('click', function(e) {
          submit.classList.remove('btn-outline-primary');
          submit.classList.add('btn-primary');
          submit.removeAttribute('disabled');
        })
      })
    }
  }
})(Drupal, drupalSettings);

(() => {
  'use strict'

  function responsiveCollapse() {
    const lg = parseInt(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg'));
    const md = parseInt(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-md'));
    let collapse = document.querySelectorAll('[data-toggle="collapse"]');
    if (window.document.documentElement.clientWidth < md) {
      [...collapse].forEach(x => {
        x.setAttribute('data-bs-toggle', x.getAttribute('data-toggle'));
        x.classList.add('collapsed');
        //        x.parentElement.classList.remove('bg-light-subtle');
        //        x.parentElement.classList.add('text-bg-logo');
      });
    } else {
      [...collapse].forEach(x => {
        x.removeAttribute('data-bs-toggle');
        x.classList.remove('collapsed');
        //        x.parentElement.classList.remove('text-bg-logo');
        //        x.parentElement.classList.add('bg-light-subtle');
      });
    }
  }

  function iframeButton() {
    const submit = document.querySelector('#edit-submit');
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.addEventListener('load', function (e) {
        setTimeout(function doTimeout(){
          const body = iframe.contentDocument.querySelector('body');
          const button = body.querySelector('.h5p-joubelui-button');
          if (button) {
            button.setAttribute('disabled', 'disabled');
            button.addEventListener('click', function(){
              submit.classList.remove('btn-outline-primary');
              submit.classList.add('btn-primary');
              submit.removeAttribute('disabled');
            });
  //          body.addEventListener('drop', function(){
  //            button.removeAttribute('disabled');
  //            console.log('drop');
  //          });
  //          body.addEventListener('mouseup', function(event){
  //            console.log(event.target);
  //          });
            const question = body.querySelectorAll('.h5p-question-content div').forEach(function(el){
              el.addEventListener('mouseup', function () {
                button.removeAttribute('disabled');
              });
              el.addEventListener('drop', function () {
                button.removeAttribute('disabled');
              });
            })
  //          console.log(question);
  //          question.addEventListener('mouseup', function(){
  //            button.removeAttribute('disabled');
  //          });
  //          question.addEventListener('drop', function(){
  //            button.removeAttribute('disabled');
  //          })
          } else {
            setTimeout(doTimeout(), 10);
          }
        }, 10);
      });
    }
  }

  function iframeButton1() {
    const submit = document.querySelector('#edit-submit');
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.addEventListener('load', function(e) {
        const body = iframe.contentDocument.querySelector('body');
        if (body) {
          body.addEventListener('click', function (event) {
            if (event.target.matches('.h5p-joubelui-button')) {
              submit.classList.remove('btn-outline-primary');
              submit.classList.add('btn-primary');
              submit.removeAttribute('disabled');
            }
          });
  //        body.addEventListener('click', function (event) {
  //          if (event.target.matches('.h5p-joubelui-button')) {
  //            submit.classList.remove('btn-outline-primary');
  //            submit.classList.add('btn-primary');
  //            submit.removeAttribute('disabled');
  //          } else {
  //            const button = body.querySelector('.h5p-joubelui-button');
  //            button.removeAttribute('disabled');
  //          }
  //        });
          body.addEventListener('drop', function (event) {
            const button = body.querySelector('.h5p-joubelui-button');
            button.removeAttribute('disabled');
            console.log('drop');
          });
          body.addEventListener('mouseup', function (event) {
            const button = body.querySelector('.h5p-joubelui-button');
            button.removeAttribute('disabled');
            console.log('mouseup')
          })
        }
  //      const drag = iframe.contentDocument.querySelector('.h5p-drag-draggables-container > div');
  //      if (drag) {
  //        body.addEventListener('mouseup', function (event) {
  //          console.log(event.target);
  //          const button = body.querySelector('.h5p-joubelui-button');
  //          button.removeAttribute('disabled');
  //        });
  //      }
        setTimeout(function doTimeout() {
          const body = iframe.contentDocument.querySelector('body');
          const button = body.querySelector('.h5p-joubelui-button');
          if (button) {
            button.setAttribute('disabled', 'disabled');
          } else {
  //          setTimeout(doTimeout(), 10);
          }
        }, 10);

      });
    }
  }

  window.addEventListener('DOMContentLoaded', function () {
//      iframeButton();
  }, false);
  window.addEventListener('DOMNodeInserted', function(e) {
    console.log('DOMNodeInserted');
    console.log(e);
  })
  window.addEventListener('load', function () {
    responsiveCollapse();
    iframeButton();
  }, false);
  window.addEventListener('resize', function () {
    responsiveCollapse();
  }, false);
})();

/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

(() => {
  'use strict'

  const getStoredTheme = () => localStorage.getItem('theme')
  const setStoredTheme = theme => localStorage.setItem('theme', theme)

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  const setTheme = theme => {
    if (theme === 'auto') {
      document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'))
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  setTheme(getPreferredTheme())

  const showActiveTheme = (theme, focus = false) => {
    const themeSwitcher = document.querySelector('#bd-theme')

    if (!themeSwitcher) {
      return
    }

    const themeSwitcherText = document.querySelector('#bd-theme-text')
    const activeThemeIcon = document.querySelector('.theme-icon-active use')
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)
    const svgOfActiveBtn = btnToActive.querySelector('svg use').getAttribute('href')

    document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
      element.classList.remove('active')
      element.setAttribute('aria-pressed', 'false')
    })

    btnToActive.classList.add('active')
    btnToActive.setAttribute('aria-pressed', 'true')
    activeThemeIcon.setAttribute('href', svgOfActiveBtn)
    const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`
    themeSwitcher.setAttribute('aria-label', themeSwitcherLabel)

    if (focus) {
      themeSwitcher.focus()
    }
  }

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme()
    if (storedTheme !== 'light' && storedTheme !== 'dark') {
      setTheme(getPreferredTheme())
    }
  })

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme())

    document.querySelectorAll('[data-bs-theme-value]')
      .forEach(toggle => {
        toggle.addEventListener('click', () => {
          const theme = toggle.getAttribute('data-bs-theme-value')
          setStoredTheme(theme)
          setTheme(theme)
          showActiveTheme(theme, true)
        })
      })
  })
})();
